import { resolveIconComponent } from "./iconLibrary.constants";

// Small glyph used in CardsEditor's collapsed-card header: resolves an
// AntD icon name to its real icon when recognized (ourAdvantage's
// migrated cards), otherwise renders the raw stored value as-is — covers
// FAQ's still-emoji `icon` field (explicitly unmigrated) and any
// unrecognized/legacy value gracefully, never blank.
function CardIconGlyph({ icon }) {
    const Icon = resolveIconComponent(icon);
    if (Icon) return <Icon />;
    return <>{icon || "▪"}</>;
}

export { CardIconGlyph };
